var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrixMembre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8446 48.5329C39.0989 48.5329 48.2224 39.4095 48.2224 28.1551C48.2224 16.9008 39.0989 7.77734 27.8446 7.77734C16.5902 7.77734 7.4668 16.9008 7.4668 28.1551C7.4668 39.4095 16.5902 48.5329 27.8446 48.5329Z",
    fill: "#FDA9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9084 36.3936C25.5325 36.3936 25.2262 36.0896 25.2262 35.7163V32.2788C25.2262 31.4977 24.5862 30.8641 23.8013 30.8641H20.5059C20.13 30.8641 19.8237 30.56 19.8237 30.1868V26.1266C19.8237 25.7534 20.13 25.4493 20.5059 25.4493H23.8013C24.5881 25.4493 25.2262 24.8139 25.2262 24.0346V20.5953C25.2262 20.222 25.5325 19.918 25.9084 19.918H29.9979C30.3738 19.918 30.6801 20.222 30.6801 20.5953V24.0328C30.6801 24.8139 31.3201 25.4475 32.105 25.4475H35.4004C35.7763 25.4475 36.0826 25.7515 36.0826 26.1248V30.185C36.0826 30.5582 35.7763 30.8623 35.4004 30.8623H32.105C31.3183 30.8623 30.6801 31.4977 30.6801 32.277V35.7145C30.6801 36.0877 30.3738 36.3918 29.9979 36.3918H25.9084V36.3936ZM26.5356 25.3328C25.7489 25.3328 25.1107 25.9682 25.1107 26.7475V29.5641C25.1107 30.3452 25.7507 30.9788 26.5356 30.9788H29.3726C30.1593 30.9788 30.7975 30.3434 30.7975 29.5641V26.7475C30.7975 25.9664 30.1574 25.3328 29.3726 25.3328H26.5356Z",
    fill: "#E52326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrixMembre);
export default __webpack_public_path__ + "static/media/PrixMembre.87918285e452121cd863bbc69ad779b1.svg";
export { ForwardRef as ReactComponent };